module.exports = __webpack_public_path__ + "img/yangliu.d843e94b.png";